export default "__VITE_ASSET__V4hWxSZa__"